import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { isEmpty } from 'lodash';

import StatusLabel from 'components/status-label/StatusLabel';
import Tooltip from 'components/Tooltip';

import './mention-card-status-labels.scss';

type Props = {
  matchedSearchTerm: string,
  additionalSearchTerms: string,
  additionalSearchTermCount: number,
  hideAdditionalStatusLabel?: boolean
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: [],
  allowedAttributes: {}
};

class MentionCardStatusLabels extends React.PureComponent<Props> {
  getUpdatedSearchTerm(searchTerm: string): string {
    const sanitizedSearchTerm = sanitizeHtml(searchTerm, SANITIZE_HTML_CONFIG);

    return sanitizedSearchTerm.replace('+', ' + '); // `+` is used for multi-query
  }

  renderAdditional(): React.ReactNode {
    const { additionalSearchTerms, additionalSearchTermCount } = this.props;

    return (
      <Tooltip
        className="mention-card-status-labels__tooltip"
        message={this.getUpdatedSearchTerm(additionalSearchTerms)}
        width="auto-compact"
        textAlign="left"
      >
        <StatusLabel
          label={`+${additionalSearchTermCount}`}
          type="neutral"
          layout="slim"
        />
      </Tooltip>
    );
  }

  renderMatched(): React.ReactNode {
    const { matchedSearchTerm } = this.props;
    const updatedMatchedSearchTerm = this.getUpdatedSearchTerm(matchedSearchTerm);

    return (
      <div
        className="mention-card-status-labels__label"
        title={updatedMatchedSearchTerm}
      >
        <StatusLabel
          label={updatedMatchedSearchTerm}
          type="neutral"
          layout="slim"
          className="mention-card-status-labels__overflow text-overflow-ellipsis"
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { hideAdditionalStatusLabel, additionalSearchTerms, additionalSearchTermCount } = this.props;

    return (
      <div
        className="mention-card-status-labels"
        data-qa="mention-card-status-labels"
      >
        {this.renderMatched()}
        {
          !hideAdditionalStatusLabel && !isEmpty(additionalSearchTerms) && additionalSearchTermCount > 0 &&
            this.renderAdditional()
        }
      </div>
    );
  }
}

export default MentionCardStatusLabels;
